/**
 * Generates random integer within the given range.
 *
 * Args:
 *      minimum (Number): Lower-bound (inclusive).
 *      maximum (Number): Upper-bound (exclusive).
 *
 * Returns:
 *      (Number) Pseudo-random integer.
 */
export function randomNumber(minimum, maximum) {
    const min = Math.ceil(minimum);
    const max = Math.floor(maximum);

    return Math.floor(Math.random() * (max - min)) + min;
}

/**
 * Reduces fraction to simplest form.
 *
 * Args:
 *      fraction (String): Fraction represented as a string.
 *
 * Returns:
 *      (String) Simplified fraction.
 *
 * Example:
 *      reduceFraction("20/40"); // returns "1/2"
 */
export function reduceFraction(fraction) {
    const barIndex = fraction.indexOf('/');
    const numerator = fraction.slice(0, barIndex);
    const denominator = fraction.slice(barIndex + 1);

    // Euclid's algorithm
    let gcd = (a, b) => (b ? gcd(b, a % b) : a);

    gcd = gcd(numerator, denominator);

    return `${ numerator / gcd }/${ denominator / gcd }`;
}
